import React from "react";
import { Action } from "../../services/types";
import { ActionButton } from "./ActionButton";

interface ActionsProps {
	actions: Action[];
}

export const Actions = ({ actions }: ActionsProps): JSX.Element | null => {
	if (!actions.length || actions.every((action) => action.hide)) {
		return null;
	}

	return (
		<div className="actions" data-testid="e-order-actions-container">
			{actions.map((action) => {
				return (
					<ActionButton
						key={action.text}
						text={action.text}
						isPrimary={action.isPrimary}
						onClick={action.onClick}
						isLoading={action.isLoading}
						data-testid={action["data-testid"]}
						hide={action.hide}
					/>
				);
			})}
		</div>
	);
};
